// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"UserFavoritesNavigation_layoutSwitch__GJXKq","paginationSwitch":"UserFavoritesNavigation_paginationSwitch__yimgR"};